(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name alert.factory:AlertService
   *
   * @description
   *
   */
  angular
      .module('alert')
      .factory('AlertService', AlertService);

  function AlertService($uibModal) {

    var AlertServiceBase = {};

    AlertServiceBase.infoAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/info-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: function (data) {
          this.data = data;
        },
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.confirmationAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/confirmation-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: function (data) {
          this.data = data;
        },
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.eInvoiceArchiveAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/archive-einvoice-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: function (data) {
          this.data = data;
        },
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    /*
     *  Required data:
     *  {paymentName: "Name"}
     */
    AlertServiceBase.deletedPaymentAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/deleted-payment-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: function (data) {
          this.data = data;
        },
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.blockCardAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/block-card-alert.tpl-html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: function (data) {
          this.data = data;
        },
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.imageAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/image-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: function (data) {
          this.data = data;
        },
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.viberDeactivateAlert = function (data) {
      return $uibModal.open({
        templateUrl: 'alert/viber-deactivation.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: function (data) {
          this.data = data;
        },
        resolve: {
          data: data
        },
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.paymentsReturnInfo = function () {
      return $uibModal.open({
        templateUrl: 'alert/payments-return-info.tpl.html',
        size: 'md',
        bindToController: true,
        controllerAs: 'vm',
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.updateMobileSetting = function () {
      return $uibModal.open({
        templateUrl: 'alert/update-mobile-setting.tpl.html',
        size: 'lg',
        backdrop: 'static'
      }).result;
    };

    AlertServiceBase.showRejectEDocumentWarning = function () {
      return $uibModal.open({
        templateUrl: 'alert/reject-e-document-alert.tpl.html',
        size: 'lg',
        bindToController: true,
        controllerAs: 'vm',
        controller: function () {
          var vm = this;
          vm.tempObj = {
            note: ''
          }
        },
        resolve: {

        },
        backdrop: 'static'
      }).result;
    };

    return AlertServiceBase;
  }

}());
